import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        outline:
          "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        info: "bg-info text-info-foreground shadow-sm hover:bg-info/90",
        success: "bg-success text-success-foreground shadow-sm hover:bg-success/90",
        warning: "bg-warning text-warning-foreground shadow-sm hover:bg-warning/90",
        danger: "bg-danger text-danger-foreground shadow-sm hover:bg-danger/90",
        dark: "bg-dark text-dark-foreground shadow-sm hover:bg-dark/90",
        white: "bg-white-custom text-white-custom-foreground border border-white-custom-border shadow-sm hover:bg-white-custom/90",

        "soft": "bg-primary/10 text-primary hover:bg-primary/20",
        "soft-primary": "bg-primary/10 text-primary hover:bg-primary/20",
        "soft-secondary": "bg-secondary/50 text-secondary-foreground hover:bg-secondary/80",
        "soft-info": "bg-info/10 text-info hover:bg-info/20",
        "soft-success": "bg-success/10 text-success hover:bg-success/20",
        "soft-warning": "bg-warning/10 text-warning hover:bg-warning/20",
        "soft-danger": "bg-danger/10 text-danger hover:bg-danger/20",

        "outline-primary": "border border-primary text-primary hover:bg-primary/10",
        "outline-secondary": "border border-secondary text-secondary-foreground hover:bg-secondary/50",
        "outline-info": "border border-info text-info hover:bg-info/10",
        "outline-success": "border border-success text-success hover:bg-success/10",
        "outline-warning": "border border-warning text-warning hover:bg-warning/10",
        "outline-danger": "border border-danger text-danger hover:bg-danger/10",
      },
      size: {
        default: "h-9 px-4 py-2",
        xs: "h-7 text-xs px-2",
        sm: "h-8 rounded-md px-3 text-xs",
        md: "h-9 px-4 py-2 text-sm ",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
